import React from 'react';
import PropTypes from 'prop-types';
import FroalaEditor from 'react-froala-wysiwyg';

import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/js/plugins.pkgd.min';
import 'froala-editor/js/languages/pt_br';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/plugins.pkgd.min.css';

const apiBaseUrl = String(process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');

const FroalaRequirementEditor = ({ value, onChange, disabled, requisiteId }) => {
  const cAccessToken = localStorage.getItem('cAccessToken') || '';
  const cEditorUploadUrl = `${apiBaseUrl}/api/requisite/editor-upload`;

  const config = {
    key: process.env.REACT_APP_FROALA_LICENSE_KEY || '',
    language: 'pt_br',
    placeholderText: 'Digite a descrição do requisito...',
    attribution: false,
    charCounterCount: false,
    toolbarSticky: false,
    toolbarButtons: [
      'bold', 'italic', 'underline', 'strikeThrough', '|',
      'fontFamily', 'fontSize', 'formatOL', 'formatUL', 'align', '|',
      'insertLink', ...(requisiteId ? ['insertImage'] : []), 'insertTable', 'undo', 'redo', 'html',
    ],
    imageUploadURL: requisiteId ? cEditorUploadUrl : undefined,
    imageUploadMethod: 'POST',
    imageUploadParam: 'fImage',
    imageUploadParams: requisiteId ? { nAreaId: requisiteId } : undefined,
    imageMaxSize: 2 * 1024 * 1024,
    requestHeaders: {
      Authorization: `Bearer ${cAccessToken}`,
    },
    pasteIgnoreFormatting: false,
    pastePlain: false,
    pasteAllowedStyleProps: [
      'font-style', 'font-weight', 'text-decoration', 'text-align',
      'color', 'background-color', 'font-size', 'width', 'height', 'border',
    ],
  };

  return (
    <FroalaEditor
      model={value || '<p></p>'}
      onModelChange={onChange}
      config={{ ...config, readOnly: disabled }}
    />
  );
};

FroalaRequirementEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  requisiteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

FroalaRequirementEditor.defaultProps = {
  value: '',
  disabled: false,
  requisiteId: null,
};

export default FroalaRequirementEditor;
